import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "one-page-navigation__wrapper" }
const _hoisted_2 = { class: "one-page-navigation__container" }
const _hoisted_3 = { class: "one-page-navigation__items" }
const _hoisted_4 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.isHidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["one-page-navigation", {'one-page-navigation--sticky': _ctx.isSticky}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("nav", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["one-page-navigation__item", {
              'one-page-navigation__item--active': _ctx.isNavItemActive(item),
              'one-page-navigation__item--disabled': item.disabled,
            }]),
                  key: item.anchor,
                  href: `#${item.anchor}`,
                  onClick: ($event: any) => (_ctx.onItemClick($event, item)),
                  ref_for: true,
                  ref: _ctx.isNavItemActive(item) ? 'activeNavElement' : null
                }, _toDisplayString(item.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}